import { useContext } from "react";
import AuthContext from "../accounts/context/AuthProvider";

const useAuth = () => {
  //useDebugValue(auth, (auth) => (auth?.user ? "Logged In" : "Logged Out"));
  return useContext(AuthContext);
};

export default useAuth;
